import { Eyebrow, Reveal } from "@/components/Reveal";

const PINS = [
  { name: "Mawun · Pachamama", lat: -8.88, lon: 116.22, main: true },
  { name: "Mataram", lat: -8.583, lon: 116.117 },
  { name: "Lombok Airport (LOP)", lat: -8.757, lon: 116.277 },
  { name: "Gili Islands", lat: -8.35, lon: 116.05 },
  { name: "Mt Rinjani", lat: -8.411, lon: 116.457 },
];

const FACTS = [
  { k: "≈ 35 km", l: "east of Bali across the Lombok Strait" },
  { k: "8.6° S", l: "same latitude belt as Bali & Rio" },
  { k: "2h 15m", l: "flight from Singapore · 25 min from Bali" },
  { k: "35 min", l: "airport to Mawun by car" },
];

const BBOX = "115.20,-9.40,117.20,-7.90";
const OSM = `https://www.openstreetmap.org/export/embed.html?bbox=${BBOX}&layer=mapnik&marker=-8.88,116.22`;

export function WhereIsLombok() {
  return (
    <section className="mx-auto mt-24 max-w-[1440px] px-6 md:mt-36 md:px-10" data-testid="lombok-map-section">
      <Reveal>
        <Eyebrow>Where it is</Eyebrow>
        <h2 className="mt-5 font-display text-4xl leading-[1.05] md:text-6xl">
          One island east <em className="text-terracotta">of Bali</em>
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-8">
          <div className="relative overflow-hidden rounded-2xl border border-pine/10 bg-sand">
            <iframe
              title="Map of Lombok, Indonesia"
              src={OSM}
              loading="lazy"
              className="aspect-[16/10] w-full grayscale-[0.25] contrast-[1.05]"
              data-testid="lombok-map"
            />
            <div className="pointer-events-none absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-cream backdrop-blur">
              Lombok · West Nusa Tenggara · Indonesia
            </div>
          </div>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.16em] text-sage">
            Map © OpenStreetMap contributors · pin marks Mawun, our home base
          </p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4">
          <div className="rounded-2xl bg-ink p-8 text-cream">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Getting here</p>
            <div className="mt-6 space-y-5">
              {FACTS.map((f) => (
                <div key={f.k} className="border-t border-cream/10 pt-4">
                  <p className="font-display text-2xl">{f.k}</p>
                  <p className="mt-1 text-sm text-cream/65">{f.l}</p>
                </div>
              ))}
            </div>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-gold">On the map</p>
            <ul className="mt-4 space-y-2 text-sm">
              {PINS.map((p) => (
                <li key={p.name} className="flex items-center gap-3 text-cream/85">
                  <span className={`h-2 w-2 rounded-full ${p.main ? "bg-terracotta" : "bg-cream/40"}`} />
                  {p.name}
                  <span className="ml-auto font-mono text-[10px] text-cream/40">
                    {Math.abs(p.lat).toFixed(2)}° S · {p.lon.toFixed(2)}° E
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
